/*
  <pickup-availability>: shows where a variant can be picked up and opens a
  dialog listing every location. The first render comes from Liquid; when the
  variant changes the content is fetched from sections/pickup-availability.liquid.
*/
if (!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    connectedCallback() {
      if (!this.ready) {
        this.ready = true;
        this.addEventListener('click', (event) => this.onClick(event));
      }
      this.stopListening = Theme.on('variant:changed', (event) => this.onVariantChange(event.detail));
    }

    disconnectedCallback() {
      if (this.stopListening) this.stopListening();
      if (this.request) this.request.abort();
    }

    get dialog() {
      return this.querySelector('[data-pickup-dialog]');
    }

    onClick(event) {
      const dialog = this.dialog;
      if (!dialog) return;
      if (event.target.closest('[data-pickup-open]')) {
        this.open(dialog);
      } else if (event.target.closest('[data-pickup-close]') || this.isBackdropClick(event, dialog)) {
        dialog.close();
      }
    }

    /* The backdrop reports the dialog as its target, and so does empty space inside the panel. */
    isBackdropClick(event, dialog) {
      if (event.target !== dialog) return false;
      const box = dialog.getBoundingClientRect();
      return (
        event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom
      );
    }

    open(dialog) {
      if (dialog.open || typeof dialog.showModal !== 'function') return;
      dialog.addEventListener('close', () => Theme.unlockScroll(), { once: true });
      dialog.showModal();
      Theme.lockScroll();
    }

    async onVariantChange(detail) {
      if (!detail || detail.sectionId !== this.dataset.sectionId) return;
      if (this.request) this.request.abort();

      const variant = detail.variant;
      if (!variant || !variant.available) {
        this.clear();
        return;
      }

      this.request = new AbortController();
      const url = new URL(this.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', variant.id);

      try {
        const html = await Theme.fetchSection(url.toString(), 'pickup-availability', { signal: this.request.signal });
        const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pickup-content]');
        if (!content || !content.children.length || content.dataset.variantId !== String(variant.id)) {
          this.clear();
          return;
        }
        this.replaceChildren(...content.children);
      } catch (error) {
        if (error.name !== 'AbortError') this.clear();
      }
    }

    clear() {
      const dialog = this.dialog;
      if (dialog && dialog.open) dialog.close();
      this.replaceChildren();
    }
  }

  customElements.define('pickup-availability', PickupAvailability);
}
